import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/GogoWwz/TMagic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import DemoBlock from '..//DemoBlock/DemoBlock.tsx';
import IconMap from './IconMap.ts';
import Icon from './icon.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "icon"
    }}>{`Icon`}</h1>
    <h3 {...{
      "id": "颜色和尺寸"
    }}>{`颜色和尺寸`}</h3>
    <Playground __position={0} __code={'<DemoBlock>\n  <Icon icon=\"arrow-down\" size=\"32\" color=\"#4b5cc4\" />\n  <Icon icon=\"arrow-up\" size=\"32\" color=\"#ed3321\" />\n  <Icon icon=\"arrow-right\" size=\"32\" color=\"#fbda41\" />\n  <Icon icon=\"arrow-left\" size=\"32\" color=\"#41b349\" />\n</DemoBlock>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      DemoBlock,
      IconMap,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <DemoBlock mdxType="DemoBlock">
    <Icon icon="arrow-down" size="32" color="#4b5cc4" mdxType="Icon" />
    <Icon icon="arrow-up" size="32" color="#ed3321" mdxType="Icon" />
    <Icon icon="arrow-right" size="32" color="#fbda41" mdxType="Icon" />
    <Icon icon="arrow-left" size="32" color="#41b349" mdxType="Icon" />
  </DemoBlock>
    </Playground>
    <h3 {...{
      "id": "图标集合"
    }}>{`图标集合`}</h3>
    <DemoBlock mdxType="DemoBlock">
  <ul className="tm-demo-iconlist">
    {IconMap.map(name => {
          return <li key={name} className="tm-demo-icon">
            <i><Icon icon={name} mdxType="Icon" /></i>
            <div>{name}</div>
          </li>;
        })}
  </ul>
    </DemoBlock>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      